import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TypeAlert } from '@core/components/symbol-alert/symbol-alert.types';

@Component({
    selector     : 'symbol-alert',
    templateUrl  : './symbol-alert.component.html',
    styleUrls    : ['./symbol-alert.component.scss'],
    encapsulation: ViewEncapsulation.None,
    exportAs     : 'symbolAlert'
})
export class SymbolAlertComponent implements OnInit {
 
 
    @Input() typeAlert: TypeAlert = 'error';
   

    /**
     * Constructor
     */
    constructor()
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------
 
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    ngOnInit(){ }

}
